import http from '../http';

// 获取可转账的房型、房间信息
const fetchTransferTargets = () => {
  return http({
    url: '/rooms/transfer/list',
  });
};

// 确认转账
const confirmTransfer = (data) => {
  return http({
    url: '/bill/transfer',
    method: 'POST',
    data,
  });
};

export { fetchTransferTargets, confirmTransfer };
